<template>
   <!--门磁-->
   <div>
        <TableBlock ref="tableData" :columns="columns" :action="action" :showBtn="true" :ispage="true" :autRequest="false"  :param="param" :navHeight="270"  @checkVal="getCheckVal">
           <div class="common-space-between">
               <div class="common-space-around">
                   <InputBlock title="指令名称">
                      <el-input v-model="param.name" :size="this.$store.state.inputSize" placeholder="请输入名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                   </InputBlock>
                   <!-- <InputBlock title="主题">
                      <el-input v-model="param.topic" :size="this.$store.state.inputSize" placeholder="请输入主题" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                   </InputBlock>
                   <InputBlock title="指令">
                      <el-input v-model="param.cmd" :size="this.$store.state.inputSize" placeholder="请输入指令" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                   </InputBlock> -->
                   <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
                   <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
               </div>
               <el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">新增</el-button>
           </div>
        </TableBlock>
        <!--新增编辑-->
        <AddEidtBlock ref="child" />
   </div>
 </template>
 <script>
 import TableBlock from '@/components/component-Table/block-table.vue'
 import AddEidtBlock from './addEidt.vue'
 import {columns} from './columns';
 import {iotApi} from '@/utils/config'
 import {getFun } from '@/utils/httpFun';
 export default {
   name: 'index',
   components:{
       TableBlock:TableBlock,
       AddEidtBlock:AddEidtBlock
   },
   data:()=>({  
      listType:[],
      action:iotApi.CMDLIST,
      columns:[],    //表头
      param:{        //请求参数
         deviceTypeId:"",
         cmd:"",
         name:"",
         topic:"",
      }     
   }),
   created(){
      this.columns = columns(this);
   },
   mounted(){
     let eqData = JSON.parse(localStorage.getItem("EQTYPEVALE"))
     this.param.deviceTypeId = eqData.id    
     this.$nextTick(res=>{
        this.$refs.tableData.getDatas()
     })
   },
   methods:{
    
     //新增 
     addBtn(){
        let datas = {
            mark:"add",
            deviceTypeId:this.param.deviceTypeId,
            listData:{}
        } 
        this.$refs.child.openBtn(datas)
     },
      //编辑
      eidtBtn(ev){
         let datas = {
            mark:"eidt",
            deviceTypeId:this.param.deviceTypeId,
            listData:ev
         }
         this.$refs.child.openBtn(datas) 
     },
     //重置从第一页开始
     resetBtn(){
        this.param.cmd = ""
        this.param.topic = ""
        this.param.name = ""
        this.$nextTick(res=>{
            this.$refs.tableData.resetHttp() 
        })
     },

     //搜索
     searchBtn(ev){
       this.$nextTick(res=>{
           this.$refs.tableData.resetHttp() 
       })
     },

     //删除指令
     deleteBtn(ev){
        console.log("删除",ev)
        this.$confirm('确认要删除'+ev.name+"?", '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            customClass:"popDeleteW",
         }).then(() => {
             getFun(iotApi.DELETECMD+ev.id,{},res=>{
                 if(res.data){
                    this.$refs.tableData.getDatas() 
                 }
             })
         }).catch(() => {

         }); 
     },

     //复选框的值   
     getCheckVal(val){
       console.log(val)
     }
   }
 }
 </script>
 <style lang="scss" scoped>
      .titleText{
         font-size: 14px;
         color: #606266;
         margin-right: 10px;
      }
      .warp-tree{
         margin-right: 10px;
      }
      ::v-deep .el-button--mini{
        padding: 5px 8px;
      }
     
 </style>
 